// extracted by mini-css-extract-plugin
export default {"container":"ChronologyItem_container__Y74qj","title":"ChronologyItem_title__YzRpO","date":"ChronologyItem_date__D6nPh"};